import * as helper from 'App/util/common/helper';
import autoNav from 'App/autoform/_nav';

export default {
  items: [
    {
      name: 'Dashboard',
      url: helper.getPath('dashboard'),
      icon: 'icon-chart',
    },
    {
      name: 'Patient',
      url: helper.getPath('patient'),
      icon: 'icon-user',
      children: [
        {
          name: 'File Export',
          url: helper.getPath('patient/export'),
          icon: 'icon-arrow-down-circle',
          badge: {
            variant: 'info',
            text: 'NEW'
          }
        }
      ]
    },
    // {
    //   name: 'Settings',
    //   url: helper.getPath('settings'),
    //   icon: 'icon-wrench',
    // },
    {
      name: 'Statistics',
      url: helper.getPath('statistics'),
      icon: 'icon-chart',
      children: [
        {
          name: 'PID Diagnosis',
          url: helper.getPath('statistics/pid'),
          icon: 'icon-pie-chart',
        },

        {
          name: 'Country Distribution',
          url: helper.getPath('statistics/country'),
          icon: 'icon-map',
        },
        {
          name: 'Coverage Map',
          url: helper.getPath('statistics/coverage'),
          icon: 'icon-map',
        },
        {
          name: 'Gender Distribution',
          url: helper.getPath('statistics/gender'),
          icon: 'icon-people',
        }
      ]
    },
    // ...autoNav.items
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js